import styled from 'styled-components';
export var StyledTabPanel = styled.div.withConfig({
  displayName: "TabPanelstyles__StyledTabPanel",
  componentId: "sc-arj2m5-0"
})(["outline:none;padding:var(--dentsu-spacing-36) var(--dentsu-spacing-96);"]);